module.exports = __webpack_public_path__ + "static/media/291509.80c18b07.png";